import { environment } from '../../../../environments/environment';
// import * as angular from 'angular';

(function () {
  'use strict';

  angular.module('app').service('ProviderCreditNoteService', ProviderCreditNoteService);

  ProviderCreditNoteService.$inject = [
    'RestResource',
    '$translate',
    '$filter',
    'UtilService',
    'SessionService',
    'ProviderCreditNoteModalService',
    'ModalWindowConfirmService',
    'WindowModalService',
    'FileSaver',
  ];

  function ProviderCreditNoteService(
    RestResource,
    $translate,
    $filter,
    UtilService,
    SessionService,
    ProviderCreditNoteModalService,
    ModalWindowConfirmService,
    WindowModalService,
    FileSaver
  ) {
    var utils = new UtilService(this);

    $translate = $filter('translate');

    var apiUrl = environment.apiEndpoint + 'provider_credit_notes';

    var service = {
      getFilterCriteria: getFilterCriteria,
      getProviderCreditNotes: getProviderCreditNotes,
      getProviderCreditNote: getProviderCreditNote,
      saveProviderCreditNote: saveProviderCreditNote,
      deleteProviderCreditNote: deleteProviderCreditNote,
      removeProviderCreditNoteItems: removeProviderCreditNoteItems,
      openSendProviderCreditNoteToProvider: openSendProviderCreditNoteToProvider,
      downloadProviderCreditNotePDF: downloadProviderCreditNotePDF,
      openRelatedTransactions: openRelatedTransactions,
      getRelatedTransactions: getRelatedTransactions,
    };

    return service;

    ////////////////

    function getFilterCriteria() {
      var filter = {
        page: 1,
        sortDir: 'desc',
        sortedBy: 'date',
      };

      return filter;
    }

    function getProviderCreditNotes(filterCriteria) {
      if (!filterCriteria) {
        filterCriteria = getFilterCriteria();
      }

      filterCriteria.company_id = SessionService.getSelectedAccountCompany().id;

      return RestResource.request(
        'get',
        apiUrl,
        filterCriteria,
        function (response) {
          response = response.data;

          if (response.meta) {
            return {
              items: response.data,
              meta: utils.getItemsMetaData(response, filterCriteria),
            };
          } else {
            return {
              items: response,
            };
          }
        },
        {}
      );
    }

    function getProviderCreditNote(id) {
      return RestResource.request(
        'get',
        apiUrl + '/' + id,
        {},
        function (response) {
          return response.data;
        },
        function () {
          // console.log(response.data.error);
          return false;
        }
      );
    }

    function saveProviderCreditNote(creditNote) {
      var method = 'post';
      var url = apiUrl;

      if (creditNote.id) {
        // edit
        method = 'put';
        url = apiUrl + '/' + creditNote.id;
      }

      function success(response) {
        var msg =
          creditNote.status === 'draft'
            ? 'PROVIDER_CREDIT_NOTE_SAVED_AS_DRAFT'
            : creditNote.id && creditNote.status !== 'draft'
            ? 'PROVIDER_CREDIT_NOTE_MODIFIED'
            : 'PROVIDER_CREDIT_NOTE_CREATED';
        utils._successMsg($translate(msg));

        return {
          status: true,
          response: response.data,
        };
      }

      function failure(response) {
        return {
          status: false,
          response: response.data,
        };
      }

      return RestResource.request(
        method,
        url,
        { provider_credit_note: creditNote },
        success,
        failure
      );
    }

    // Only for draft items
    function deleteProviderCreditNote(creditNote, successCallback) {
      let url = apiUrl + '/' + creditNote.id;

      let params = {
        title: 'DELETE_PROVIDER_CREDIT_NOTE',
        reason: 'DELETE_ITEM_REASON',
        successMsg: 'PROVIDER_CREDIT_NOTE_DELETED',
        company_id: creditNote.company_id,
      };

      utils.deleteItem(url, successCallback, params);
    }

    function removeProviderCreditNoteItems(successCallback, cancelCallback) {
      var modalParams = {
        mode: 'danger',
        title: 'CHANGE_PROVIDER_FOR_CURRENT_CREDIT_NOTE',
        body: 'CHANGE_PROVIDER_FOR_CURRENT_CREDIT_NOTE_WARNING',
      };

      var confirmCallback = function () {
        return successCallback();
      };

      ModalWindowConfirmService.open(modalParams, confirmCallback, cancelCallback);
    }

    function openSendProviderCreditNoteToProvider(providerEmail, successCallback) {
      ProviderCreditNoteModalService.openSendProviderCreditNoteToProvider(
        providerEmail,
        successCallback
      );
    }

    function downloadProviderCreditNotePDF(providerCreditNote, lang) {
      var apiUrlPdf = apiUrl + '/' + providerCreditNote.id + '/provider_credit_note_pdf.pdf';

      return RestResource.request(
        'get',
        apiUrlPdf,
        { company_id: providerCreditNote.company_id, lang: lang },
        function (response) {
          let blobVar = new Blob([response.data], { type: 'application/pdf' });

          FileSaver.saveAs(
            blobVar,
            $translate('PROVIDER_CREDIT_NOTE') +
              ' ' +
              providerCreditNote.provider_credit_note_number +
              '.pdf'
          );
        },
        function () {}
      );
    }

    function openRelatedTransactions(transaction, provider) {
      let templateUrl =
        './app/ajs/provider-credit-notes/modals/provider-credit-note-related-transactions-modal.html';

      let modalParams = {
        item: transaction,
        additionalParams: {
          providerId: provider.id,
        },
      };

      WindowModalService.open(templateUrl, modalParams);
    }

    function getRelatedTransactions(id, providerId) {
      const params = {
        skip_check_role: true,
        provider_id: providerId,
      };

      return RestResource.request(
        'get',
        apiUrl + '/' + id + '/related_transaction/',
        params,
        function (response) {
          return response.data;
        },
        function (err) {
          return err;
        }
      );
    }
  }
})();
